module.exports = __webpack_public_path__ + "img/upload_bg_06.b9376f30.png";